<script>
import PageHeader from 'dashboard/components/dahreply/PageHeader.vue';
import TicketDetail from './components/TicketDetail.vue';

export default {
  name: 'CoLivingTicketDetailPage',
  components: { PageHeader, TicketDetail },
  computed: {
    ticketId() {
      return this.$route.params.ticketId;
    },
  },
};
</script>

<template>
  <div class="flex-1 overflow-auto p-6" data-testid="co-living-ticket-page">
    <PageHeader
      :title="ticketId"
      icon="ticket"
      allow-back
      :back-url="{
        name: 'co_living_tickets',
        params: { accountId: $route.params.accountId },
      }"
    />
    <TicketDetail :ticket-id="ticketId" />
  </div>
</template>
